/**
 * Paywall event bus.
 *
 * Cross-component channel for triggering the global PaywallModal
 * without prop drilling. Two events:
 *
 *   - "paywall:open"  detail = { code, message, balance, needed_credits }
 *   - "paywall:close"
 *
 * The axios response interceptor fires `paywall:open` whenever a 402
 * comes back from the backend; the modal listens and renders. Manual
 * triggers (e.g. clicking "Upgrade plan") can also dispatch directly.
 */
const TARGET = typeof window !== "undefined" ? window : null;

export function openPaywall(detail = {}) {
    if (!TARGET) return;
    TARGET.dispatchEvent(new CustomEvent("paywall:open", { detail }));
}

export function closePaywall() {
    if (!TARGET) return;
    TARGET.dispatchEvent(new CustomEvent("paywall:close"));
}

export function onPaywallOpen(handler) {
    if (!TARGET) return () => {};
    const wrapped = (e) => handler(e.detail || {});
    TARGET.addEventListener("paywall:open", wrapped);
    return () => TARGET.removeEventListener("paywall:open", wrapped);
}

export function onPaywallClose(handler) {
    if (!TARGET) return () => {};
    TARGET.addEventListener("paywall:close", handler);
    return () => TARGET.removeEventListener("paywall:close", handler);
}
